// extracted by mini-css-extract-plugin
module.exports = {"container":"OutputTextarea_container__j09g7","textarea":"OutputTextarea_textarea__8ax5d","character-counter":"OutputTextarea_character-counter__k291S"};